import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { selectIsEffectiveAdmin, selectIsEffectiveSupportAdmin } from 'src/utilities/adminUtils';
import { useHistory, useParams, useLocation } from "react-router-dom";

import './styles.scss';

import {
    AppLayout, HelpPanel, Icon, BreadcrumbGroup, Box, Alert, ExpandableSection, Tiles,
    Container, Header, ColumnLayout, Spinner, Link, Tabs, Button, Table, SpaceBetween, Modal, FileUpload, Select, Multiselect, Input, Grid, FileInput, Checkbox,
    DatePicker, Flashbar, RadioGroup, StatusIndicator, Popover,
} from '@amzn/awsui-components-react';
import SideNav from './SideNav';
import FlexicoTreeView from '../Templates/components/FlexicoTreeView';
import { parseInfoField, isInfoUrl } from '../Templates/components/parameterInfo';
import { useAuth } from "../../context/AuthContextProvider";
import { v4 as uuidv4 } from 'uuid';
import Amplify, { Storage } from 'aws-amplify';


import { setCurrentAppId } from '../../store/userAuthSlice';
import { clearRerunData } from '../../store/flexicoRerunSlice';
import { setPendingTrigger, ActionTriggerType } from '../../store/pulseSurveyTriggerSlice';
import { FLEXICO_TRANSACTION_STATUS, FLEXICO_TEMPLATE_KEYS, CERTIFICATION_ACTION, FLEXICO_CUSTOM_ATTRIBUTE_TYPES, FLEXICO_SINGLE_VALUE_TYPES } from './Constants';
import { configureFlexicoS3, configureGenericS3 } from 'src/context/AuthContextUtility'
import { isUploaderAllowed } from '../Frisco/AccessUtilities';
import { createFlexicoTransaction, fetchDynamicQueryValues, getFlexicoTemplate } from 'src/utilities/FlexicoAPIs';
import RequiredDateColumns from '../TaskManager/RequiredDateColumns';
import { getRequiredDateColumnsByService } from '../TaskManager/api';
import { getFlexicoS3Config } from 'src/utilities/AWSServices';
import { checkIfPortalAdmin, checkIfSupportAdmin } from 'src/checkPageAccess';
import { disabled as isDisabledPlugin } from 'src/plugins/CorpReportingViewOptions'
import CustomDateTimePicker from '../Templates/components/CustomDateTimePicker';
import { reorderFieldsOnlyByIndex } from './Utility';
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { getCustomAttribute as getCustomAttributeUtil } from "../utils/customAttributeUtils";
import { updateFlexicoTemplateComment } from 'src/Ateam-BI/Templates/Utils/AppActivityUtilsAppsyncPlus';
import ProcessCommentSection from '../Templates/components/ProcessCommentSection';
import { getCurrentQuarter } from '../CorpReporting/Utility';
import { getDisplayName } from '../utils/displayNameUtils';
import appSettings from '../CorpReporting/app_settings';
import {  uploadDocumentToVault } from 'src/Ateam-BI/Vault/VaultAPIs';
import { VAULT_SERVICES } from 'src/Ateam-BI/Vault/constants';

export default (props) => {
    const userId = useSelector((globalState) => globalState.auth.userId)
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const isPortalAdmin = useSelector(selectIsEffectiveAdmin)
    const isSupportAdmin = useSelector(selectIsEffectiveSupportAdmin)
    const rerunData = useSelector((globalState) => globalState.flexicoRerun.rerunData)
    const history = useHistory();
    const userAuthenticationDetails = useAuth();
    const userLDAPS = userAuthenticationDetails.USER_LDAP_GROUPS;
    let { id: paramId } = useParams();
    let { fid: paramFid } = useParams();
    
    const id = props.id || paramId;
    const fid = props.fid || paramFid;
    
    
    const [flexicoTemplateData, setFlexicoTemplateData] = useState({})
    // Required "date" fields (from Task Manager dashboards this template's app is on),
    // fetched in the background on page entry so it's ready before submit.
    const [requiredDateDashboards, setRequiredDateDashboards] = useState(null);
    const [requiredDateLoading, setRequiredDateLoading] = useState(false);
    const [requiredDateError, setRequiredDateError] = useState('');
    // Checked "optional inputs" selections, shaped { "<dashboard_id>": { dates:[...] } },
    // written into the transaction record as task_manager_inputs at submit.
    const [taskManagerInputs, setTaskManagerInputs] = useState({});
    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState();
    const dispatch = useDispatch()
    const [activeTabId, setActiveTabId] = useState("first");
    const [isFileSelected, setIsFileSelected] = useState(false);
    const [showFileNotSeleted, setShowFileNotSeleted] = useState(false);
    const currentAppId = useSelector((globalState) => globalState.auth.currentAppId)
    const isCurrentAppAuthorised = useSelector((globalState) => globalState.auth.isCurrentAppAuthorized)
    const [showLoadingIcon, setShowLoadingIcon] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [missingFields, setMissingFields] = useState(new Set());
    const [inputFiles, setInputFiles] = useState([]);
    // const [supportedFormats, setSupportedFormats] = useState('.csv');
    const [loadingMessage, setLoadingMessage] = useState('loading, please wait..');
    const [showUploadBtn, setShowUploadBtn] = useState(false)
    const [fileReference, setFileReference] = useState('');
    const [inputSheets, setInputSheets] = useState([]);
    const [selectedSheet, setSelectedSheet] = useState('');
    const [backUrl, setBackUrl] = useState(null)
    const [uploadParameters, setUploadParameters] = useState({})
    // Non-mandatory groups render collapsed behind an opt-in checkbox; this tracks which
    // ones the user expanded (keyed by group_id). Mandatory groups are always shown.
    const [openGroups, setOpenGroups] = useState({})
    const [enableTrigger, setEnableTrigger] = useState(false)
    const [resolvedDynamicDropDownValues, setResolvedDynamicDropDownValues] = useState({})
    const [dynamicDropDownDependencies, setDynamicDropDownDependencies] = useState({})
    const [dynamicFieldTypes, setDynamicFieldTypes] = useState(['dynamic_select', 'dynamic_multi_select'])
    const [parameterError, setParameterError] = useState({})
    const [missingMandatoryDocs, setMissingMandatoryDocs] = useState([])
    const [isFlexicoDisabled, setIsFlexicoDisabled] = useState(false)
    const [disabledMessages, setDisabledMessages] = useState([])
    const [isCommentSubmitting, setIsCommentSubmitting] = useState(false)
    const [certificationChecked, setCertificationChecked] = useState(false)
    const [rerunFlashbarItems, setRerunFlashbarItems] = useState([])

    const prevRef = useRef()

    const ln = useLocation()
    useVisibleTimeTracker([{
            metricName : 'actionPerformedBy',
            metricValue : userId,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'pagePath',
            metricValue : `${ln.pathname}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        }
        ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.FLEXICO);

    // Fire-and-forget fetch of the required DATE fields for this FlexiCo template.
    // Triggered on page entry so the result is ready before the user submits.
    const fetchRequiredDateColumns = () => {
        if (!fid) return;
        setRequiredDateLoading(true);
        setRequiredDateError('');
        getRequiredDateColumnsByService(fid, 'FLEXICO')
            .then((result) => {
                setRequiredDateDashboards(Array.isArray(result) ? result : []);
            })
            .catch((e) => {
                setRequiredDateError(e?.message || 'Failed to load required date fields');
                setRequiredDateDashboards([]);
            })
            .finally(() => setRequiredDateLoading(false));
    };

    useEffect(() => {
        configureFlexicoS3()
        if (fid) {
            loadData();
            // Background-fetch required date fields on page entry.
            fetchRequiredDateColumns();
        }
        if (id) {
            dispatch(setCurrentAppId(id))
        }
        setBackUrl(getParam('back'))
        return () => {
            configureGenericS3()
        };
    }, []);



    useEffect(() => {
        configureFlexicoS3()
        return () => {
            // this now gets called when the component unmounts
        };
    }, [isCurrentAppAuthorised]);

    useEffect(() => {
        if (isAuthorized === true || isAuthorized === false) {
            setIsCheckingAccess(!isCheckingAccess);
        }
    }, [isAuthorized]);

    useEffect(() => {
        checkIfFormIsSubmittable()
        return () => {
            // this now gets called when the component unmounts
        };
    }, [uploadParameters, inputFiles, flexicoTemplateData, openGroups]);

    // Seed default values for numeric_up_down fields the user is allowed to set.
    // Done here (not during render) so we don't mutate state mid-render, and gated
    // on permission so restricted fields aren't auto-populated / auto-satisfied.
    useEffect(() => {
        const params = flexicoTemplateData?.parameters
        if (!params) return
        setUploadParameters(prev => {
            const next = { ...prev }
            let changed = false
            params.forEach((parameter) => {
                if (parameter.field_type !== 'numeric_up_down') return
                if (next[parameter.label] !== undefined) return
                if (!canUserSetParameter(parameter)) return
                const seed = parseInt(parameter.field_values?.[0], 10)
                next[parameter.label] = (isNaN(seed) || seed < 0 ? 0 : seed).toString()
                changed = true
            })
            return changed ? next : prev
        })
    }, [flexicoTemplateData, userId, userLDAPS]);

    useEffect(() => {
        onUpload(inputFiles)
        return () => {
            // this now gets called when the component unmounts
        };
    }, [inputFiles]);

    useEffect(() => {
        if (flexicoTemplateData) {
            scanDynamicParams() // scan dynamic values
        }
    }, [dynamicDropDownDependencies, flexicoTemplateData])

    useEffect(() => {
        if (!rerunData || !flexicoTemplateData?.parameters) return

        const { __rerunFileId: rerunFileId, ...rawParams } = rerunData
        dispatch(clearRerunData())

        const labelToParam = {}
        flexicoTemplateData.parameters.forEach(param => {
            if (param.label) labelToParam[param.label] = param
        })

        const newParams = {}
        const unmatchedKeys = []
        for (const key in rawParams) {
            if (key === 'triggered_by' || key === 'rerunFileId') continue
            const matched = labelToParam[key]
            if (matched) {
                let val = rawParams[key]
                if (FLEXICO_SINGLE_VALUE_TYPES.includes(matched.field_type) && Array.isArray(val)) {
                    val = val[0] || ''
                }
                newParams[matched.label] = val
            } else {
                unmatchedKeys.push(key)
            }
        }

        setUploadParameters(prev => ({ ...prev, ...newParams, ...(rerunFileId ? { rerunFileId } : {}) }))

        if (unmatchedKeys.length > 0) {
            const templateName = flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.template_name] || 'this template'
            setRerunFlashbarItems([{
                type: 'warning',
                dismissible: true,
                onDismiss: () => setRerunFlashbarItems([]),
                content: <>Due to the most recent template update to {templateName}, the following parameters must be manually input: {unmatchedKeys.map((key, i) => <React.Fragment key={key}>{i > 0 && ', '}<strong>{key}</strong></React.Fragment>)}</>
            }])
        } else {
            setRerunFlashbarItems([])
        }
    }, [flexicoTemplateData, rerunData])

    function compareJSON(obj1, obj2) {
        const changes = {};

        function compareValues(value1, value2, key) {
            if (value1 === value2) return;

            if (typeof value1 !== typeof value2) {
                changes[key] = { oldValue: value1, newValue: value2 };
                return;
            }

            if (typeof value1 === 'object' && value1 !== null && value2 !== null) {
                const nestedChanges = compareJSON(value1, value2);
                if (Object.keys(nestedChanges).length > 0) {
                    changes[key] = nestedChanges;
                }
                return;
            }

            changes[key] = { oldValue: value1, newValue: value2 };
        }

        // Check for properties in obj1
        for (const key in obj1) {
            if (obj1.hasOwnProperty(key)) {
                compareValues(obj1[key], obj2[key], key);
            }
        }

        // Check for properties in obj2 that are not in obj1
        for (const key in obj2) {
            if (obj2.hasOwnProperty(key) && !obj1.hasOwnProperty(key)) {
                changes[key] = { oldValue: undefined, newValue: obj2[key] };
            }
        }

        return changes;
    }

    const getParam = (key) => {
        const search = props?.location?.search;
        const params = new URLSearchParams(search);
        const value = params.get(key);
        return value;
    }

    const getTemplateDisplayName = () => {
        const aliasParam = getParam('alias');
        return getDisplayName(aliasParam, flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.template_name], flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.label]);
    }

    function sortParametersBasedOnHierarchy(res) {
        if(res?.parameters){
            res['parameters'] = reorderFieldsOnlyByIndex(res?.parameters)
        }
        return res
    }

    async function loadDependants(parameters) {
        const newDynamicDropDownDependencies = { ...dynamicDropDownDependencies };
        const newParameterError = { ...parameterError };

        // Create a map for quick lookup of parameters by label
        const parameterMap = new Map(parameters.map(param => [param.label, param]));

        parameters.forEach(parameter => {
            if (!newDynamicDropDownDependencies[parameter.label]) {
                newDynamicDropDownDependencies[parameter.label] = {
                    isValuesFetched: false,
                    dependantParameters: [],
                    parametersDependantOn: []
                };
            }

            // Extract parameters this parameter depends on (only if field_values exists and has values)
            const firstFieldValue = parameter.field_values?.[0];
            const parametersDependantOn = firstFieldValue?.match(/\{([^}]+)\}/g)?.map(match => match.slice(1, -1)) || [];
            newDynamicDropDownDependencies[parameter.label].parametersDependantOn = Array.from(new Set(parametersDependantOn));

            if (dynamicFieldTypes.includes(parameter.field_type) && parametersDependantOn.length > 0) {
                const invalidParams = parametersDependantOn.filter(dep => !parameterMap.has(dep));
                if (invalidParams.length > 0) {
                    newParameterError[parameter.label] = `Invalid parameter reference(s) in query: {${invalidParams.join('}, {')}}. These parameters do not exist. Please check for typos in your query.`;
                } else {
                    delete newParameterError[parameter.label];
                }
            }

            // Find parameters that depend on this parameter
            const dependantParameters = parameters
                .filter(p => p.field_values?.[0]?.includes(`{${parameter.label}}`))
                .map(p => p.label);

            newDynamicDropDownDependencies[parameter.label].dependantParameters = dependantParameters;
        });

        setDynamicDropDownDependencies(newDynamicDropDownDependencies);
        setParameterError(newParameterError);
    }

    function scanDynamicParams() {
        flexicoTemplateData?.parameters?.forEach((parameter) => {
            if (dynamicFieldTypes.includes(parameter.field_type)) {
                fetchParameterDynamicValues(parameter)
            }
        })
    }

    function checkIfAllDependantParameterValuesExist(parameter) {
        if (parameter?.field_values?.[0].includes('{')) {
            let parametersDependantOn = dynamicDropDownDependencies?.[parameter?.label]?.['parametersDependantOn']
            let allDependantsExists = true
            for (let i = 0; i < parametersDependantOn?.length; i++) {
                if (!uploadParameters.hasOwnProperty(parametersDependantOn[i])
                    || !uploadParameters[parametersDependantOn[i]]
                    || uploadParameters[parametersDependantOn[i]] == '') {
                    // atleast one dependant paremeter is not chosen in the UI
                    allDependantsExists = false
                }
            }
            return allDependantsExists
        } else {
            return true
        }
    }

    function fetchParameterDynamicValues(parameter) {
        if (checkIfAllDependantParameterValuesExist(parameter) && !dynamicDropDownDependencies?.[parameter.label]?.['isValuesFetched']) { // if all the dependant values are available and if API call is not amde for the field
            dynamicDropDownDependencies[parameter.label]['isValuesFetched'] = true
            setDynamicDropDownDependencies({ ...dynamicDropDownDependencies })

            let parametersDependantOn = dynamicDropDownDependencies[parameter.label]['parametersDependantOn']
            let parametersDependantOnInput = {}
            for (let i = 0; i < parametersDependantOn.length; i++) {
                if (Array.isArray(uploadParameters?.[parametersDependantOn[i]])) {

                    parametersDependantOnInput[parametersDependantOn[i]] =uploadParameters?.[parametersDependantOn[i]].map(item => `'${item}'`).join(',');
                } else {
                    parametersDependantOnInput[parametersDependantOn[i]] = "'" + uploadParameters[parametersDependantOn[i]] + "'";
                }
            }
            dynamicDropDownDependencies[parameter.label]['fetching'] = true
            fetchDynamicQueryValues(parameter.field_id, parametersDependantOnInput, function onSuccess(results) {
                let selectInputs = []
                let resultArray = JSON.parse(results?.data?.fetchDynamicQueryValues)
                if (resultArray.hasOwnProperty('Error')) {
                    dynamicDropDownDependencies[parameter.label]['isValuesFetched'] = false
                    setDynamicDropDownDependencies({ ...dynamicDropDownDependencies })
                    parameterError[parameter.label] = `Could not fetch from due to error ${resultArray['Error']}`
                    setParameterError({ ...parameterError })
                } else {
                    for (let i = 0; i < resultArray?.length; i++) {
                        selectInputs.push({ label: resultArray[i]['results'], value: resultArray[i]['results'] })
                    }
                    resolvedDynamicDropDownValues[parameter.label] = selectInputs
                    setResolvedDynamicDropDownValues({ ...resolvedDynamicDropDownValues })

                    parameterError[parameter.label] = null
                    setParameterError({ ...parameterError })

                    dynamicDropDownDependencies[parameter.label]['fetching'] = false
                    setDynamicDropDownDependencies({ ...dynamicDropDownDependencies })
                }

            }, function onFailure(response) {
                dynamicDropDownDependencies[parameter.label]['isValuesFetched'] = false
                dynamicDropDownDependencies[parameter.label]['fetching'] = false
                setDynamicDropDownDependencies({ ...dynamicDropDownDependencies })
                parameterError[parameter.label] = `Could not fetch from due to error ${response}`
                setParameterError({ ...parameterError })
            })
        }
    }

    const loadData = async () => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
        setLoadingMessage("loading, please wait...")
        setShowLoadingIcon(true);
        setShowUploadBtn(false)
        uploadParameters['triggered_by'] = userId
        setUploadParameters({ ...uploadParameters })
        // setProcessData()
        await Promise.all([
            new Promise((resolve, reject) => {
                getFlexicoTemplate(fid, async function onSuccess(response) {
            let res = response.data.getFlexicoTemplateRDS
            res = sortParametersBasedOnHierarchy(res)
            setFlexicoTemplateData(res)
            if(res?.parameters){
                await loadDependants(res?.parameters)
            }
            setShowLoadingIcon(false);
            // setSupportedFormats(getSupportedFormats(res))
            //trying to avoid load time by reusing redux

            let isAllowed = isPortalAdmin || await checkIfPortalAdmin(userId, currentStage)
            if (!isAllowed) {
                isAllowed = isSupportAdmin || await checkIfSupportAdmin(userId, currentStage)
            }
            // temporary if condition for internal testing - the portal/support admin conditions are ignored for CRA app to simulate normal acc users permissions
            if(currentAppId == appSettings[currentStage].appId){
                isAllowed = false
            }
            if (!isAllowed) {
                isAllowed = await isUploaderAllowed(res, userId, currentStage)
            }

            if (!isAllowed) {
                setShowLoadingIcon(false);
                setShowUploadBtn(false)
                if(id == appSettings[currentStage].appId){
                    setErrorMessage("You don't have permission to perform a trigger action. You are not part of the Uploader group for this deliverable  If you believe you should have access please contact the SEC team to request membership in the appropriate group")
                }
                else{
                    setErrorMessage("Cannot execute. Please check with the owner of the FlexiCo template for access.")
                }
            } else {
                setShowLoadingIcon(false);
                setShowUploadBtn(true)
            }
            setIsAuthorized(isAllowed)

            isDisabledPlugin({ appId: id, stage: currentStage, info: res }, function onResponse(response) {
                let messages = []
                if (response?.disabled) {
                    setIsFlexicoDisabled(true)
                    messages.push('This deliverable is disabled and not required for this quarter. If you believe this not to be correct, please contact the SEC team')
                }
                if (response?.annualOnly && getCurrentQuarter() != "Q1") {
                    setIsFlexicoDisabled(true)
                    messages.push('This deliverable is ANNUAL ONLY and not required for this quarter. If you believe this not to be correct, please contact the SEC team')
                }
                if (response?.isLocked) {
                    setIsFlexicoDisabled(true)
                    messages.push('This deliverable has been locked. If you believe this not to be correct, please contact the SEC team')
                }
                setDisabledMessages(messages)
            })
            resolve();
        }, function onFailure(response) {
            setShowLoadingIcon(false);
            setErrorMessage("Could not load template information")
            setShowUploadBtn(true)
            reject();
        })
            })
        ])
        
    } finally {
        if(!pageLoadTime.isStopped) {
        stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.FLEXICO)
        }
    }

    }



    const resetValidationErrorLogs = () => {
        setMissingFields(new Set())
    }


    const hasValue = (value) =>
        value && (Array.isArray(value) ? value.length > 0 : value.toString().trim().length > 0);

    const checkIfFormIsSubmittable = () => {
        const groups = groupAndSortParameters(flexicoTemplateData?.parameters);

        // Params the user can't fill right now (collapsed non-mandatory groups) are ignored
        // by the mandatory-parameter check so they can't block submission.
        const hiddenGroupLabels = getHiddenGroupLabels();

        // Check if all mandatory parameters have values (skipping params in hidden groups).
        const mandatoryParametersFilled = flexicoTemplateData?.parameters?.every(parameter => {
            if (parameter.is_mandatory && !hiddenGroupLabels.has(parameter.label)) {
                return hasValue(uploadParameters[parameter.label]);
            }
            return true; // Non-mandatory / hidden-group parameters don't affect submission
        }) ?? true;

        // A mandatory group must have at least one of its parameters filled in.
        const mandatoryGroupsValid = groups.every(group => {
            if (group.is_mandatory !== true) return true;
            return group.params.some(p => hasValue(uploadParameters[p.label]));
        });

        // If a nested_checkbox_group parent is selected, at least one leaf must be
        // chosen. If the parent isn't selected the value is absent, so it's ignored.
        const nestedGroupsValid = flexicoTemplateData?.parameters?.every(parameter => {
            if (parameter.field_type !== 'nested_checkbox_group') return true;
            const value = uploadParameters[parameter.label];
            if (value === undefined || value === null) return true; // parent not selected
            // parent selected (array present): require at least one chosen child
            return Array.isArray(value) && value.length > 0;
        }) ?? true;

        if (!flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.trigger_type)) {
            setEnableTrigger(false)
        } else if (flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file with parameters') {
            setEnableTrigger(((inputFiles && inputFiles.length > 0) || !flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.upload_mandatory]) && mandatoryParametersFilled && nestedGroupsValid && mandatoryGroupsValid)
        } else if (flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file only') {
            setEnableTrigger(inputFiles && inputFiles.length > 0)
        } else if (flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Parameters only') {
            setEnableTrigger(mandatoryParametersFilled && nestedGroupsValid && mandatoryGroupsValid)
        } else {
            setEnableTrigger(nestedGroupsValid && mandatoryGroupsValid)
        }
    }

    const onUpload = async (inputFiles) => {
        try {
            setLoadingMessage("loading file, please wait...")
            setShowLoadingIcon(true);
            setErrorMessage('')
            setIsFileSelected(true)
            setShowFileNotSeleted(false)
            resetValidationErrorLogs()
            setShowLoadingIcon(false);
            checkIfFormIsSubmittable()
        } catch (error) {
            setErrorMessage()
            setLoadingMessage("")
            setShowLoadingIcon(false)
        }

    }

    const ModalOkClick = () => {
        // Dispatch execute trigger for pulse survey notifications
        dispatch(setPendingTrigger(ActionTriggerType.EXECUTE));
        // Check if we have sidebar content (query parameter context)
        if (props.selectedSidebarContent) {
            // Find the History tab and trigger its action
            const historyTab = props.selectedSidebarContent.find(
                tab => tab.label.toLowerCase() === 'history'
            );
            
            if (historyTab && historyTab.action) {
                // Close the modal first
                setShowSuccessModal(false);
                // Trigger the History tab action (updates parent state + URL)
                historyTab.action();
            } else {
                // Fallback if History tab not found
                setShowSuccessModal(false);
                history.push(`/App/${id}/flexico/${fid}/history${location.search}`);
            }
        } else {
            // Fallback to original behavior if not in query parameter context
            history.push(`/App/${id}/flexico/${fid}/history${location.search}`);
        }
    }

    const getSupportedFormats = (input = flexicoTemplateData, defValue = '.xlsx') => {
        let returnValue = new Set()
        returnValue.add(defValue)
        if (input && input.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.file_types)) {
            input[FLEXICO_TEMPLATE_KEYS.file_types].forEach((item) => {
                if (item == 'CSV') {
                    returnValue.add('.csv')
                } else if (item == 'Excel') {
                    returnValue.add('.xls')
                    returnValue.add('.xlsx')
                    // returnValue.add('.xlsb')
                    returnValue.add('.xlsm')
                    // returnValue.add('.xltx')
                    // returnValue.add('.xltm')
                } else if (item == 'PDF') {
                    returnValue.add('.pdf')
                    returnValue.add('.PDF')
                } else {
                    returnValue.add(defValue)
                }
            })
        }
        return Array.from(returnValue).join(",")
    }


    const constructSelectedOptions = (values) => {
        let selectedOptions = []
        for (let i = 0; i < values.length; i++) {
            selectedOptions.push({ label: values[i], value: values[i] })
        }
        return selectedOptions
    }

    function loadAllDependantsAcrossAllLevels(changedValues) {
        let newDependants = new Set(Object.keys(changedValues));
        let queue = [...newDependants];

        while (queue.length > 0) {
            let currentKey = queue.shift();
            if (dynamicDropDownDependencies.hasOwnProperty(currentKey)) {
                let dependents = dynamicDropDownDependencies[currentKey].dependantParameters || [];
                for (let dependent of dependents) {
                    if (!newDependants.has(dependent)) {
                        newDependants.add(dependent);
                        queue.push(dependent);
                    }
                }
            }
        }

        return Array.from(newDependants);
    }

    const canUserSetParameter = (parameter) => {
        if (!parameter.limit_permissions) {
            return true;
        }
        
        if (!parameter.permissions || parameter.permissions.length === 0) {
            return false;
        }
        
        for (const permission of parameter.permissions) {
            if (permission.type === 'UPLOADER') {
                if (permission.alias?.toLowerCase() === userId?.toLowerCase()) {
                    return true;
                }
            } else if (permission.type === 'UPLOADER_LDAP') {
                const ldapGroups = typeof userLDAPS === 'string' 
                    ? userLDAPS.split(',').map(g => g.trim().toLowerCase())
                    : [];
                if (ldapGroups.includes(permission.alias?.toLowerCase())) {
                    return true;
                }
            }
        }
        
        return false;
    };

    function resetDependants() {
        if (prevRef.current != undefined) {
            let changedValues = compareJSON(prevRef.current, uploadParameters)
            // check if the changed params have dependants
            let toResetSelection = loadAllDependantsAcrossAllLevels(changedValues)
            for (const param of toResetSelection) {
                if (changedValues.hasOwnProperty(param)) {
                    // reset for all except the changed
                    continue
                }
                dynamicDropDownDependencies[param]['isValuesFetched'] = false
                resolvedDynamicDropDownValues[param] = null
                uploadParameters[param] = null
            }
            setDynamicDropDownDependencies({ ...dynamicDropDownDependencies })
            setResolvedDynamicDropDownValues({ ...resolvedDynamicDropDownValues })
            setUploadParameters({ ...uploadParameters })
        }

        scanDynamicParams()
        // saving the older state inorder to detect changes to an already selected dynamic field
        prevRef.current = JSON.parse(JSON.stringify(uploadParameters))
    }

    const getParameterItems = (value, index) => {
        let element = <></>
        if (value.label?.startsWith('flexico_internal')) {
            uploadParameters[value.label] = value.field_values
            return element
        }
        
        const hasPermission = canUserSetParameter(value);
        const isDisabled = !hasPermission;

        if (value.field_type == 'select') {
            let options = []
            value.field_values?.forEach((field_value) => {
                options.push({ label: field_value, value: field_value })
            })
            element = <Select
                selectedOption={uploadParameters[value.label]?.length > 0 ? { label: uploadParameters[value.label], value: uploadParameters[value.label] } : ''}
                onChange={({ detail }) => {
                    uploadParameters[value.label] = detail.selectedOption.label
                    setUploadParameters({ ...uploadParameters })
                    resetDependants()
                }

                }
                options={options}
                disabled={isDisabled}
            />
        } else if (value.field_type == 'multi_select') {
            let options = []
            value.field_values?.forEach((field_value) => {
                options.push({ label: field_value, value: field_value })
            })
            element = <Multiselect
                selectedOptions={uploadParameters[value.label] ? constructSelectedOptions(uploadParameters[value.label]) : []}
                onChange={({ detail }) => {
                    let parsedOptions = []
                    detail.selectedOptions?.forEach((selectedOption) => {
                        parsedOptions.push(selectedOption.label)
                    })
                    uploadParameters[value.label] = parsedOptions
                    setUploadParameters({ ...uploadParameters })
                    resetDependants()
                }
                }
                options={options}
                placeholder="Choose options"
                disabled={isDisabled}
            />
        } else if (value.field_type == 'radio_group') {
            let items = []
            value.field_values?.forEach((field_value) => {
                items.push({ label: field_value, value: field_value })
            })
            element = <RadioGroup
                value={uploadParameters[value.label] || null}
                onChange={({ detail }) => {
                    uploadParameters[value.label] = detail.value
                    setUploadParameters({ ...uploadParameters })
                    resetDependants()
                }}
                items={items}
                direction="horizontal"
                readOnly={isDisabled}
            />
        } else if (value.field_type == 'checkbox_group') {
            let selected = Array.isArray(uploadParameters[value.label]) ? uploadParameters[value.label] : []
            element = <SpaceBetween direction="horizontal" size="xs">
                {value.field_values?.map((field_value) => (
                    <Checkbox
                        key={field_value}
                        checked={selected.includes(field_value)}
                        onChange={({ detail }) => {
                            let current = Array.isArray(uploadParameters[value.label]) ? [...uploadParameters[value.label]] : []
                            if (detail.checked) {
                                if (!current.includes(field_value)) current.push(field_value)
                            } else {
                                current = current.filter((v) => v !== field_value)
                            }
                            uploadParameters[value.label] = current
                            setUploadParameters({ ...uploadParameters })
                            resetDependants()
                        }}
                        disabled={isDisabled}
                    >{field_value}</Checkbox>
                ))}
            </SpaceBetween>
        } else if (value.field_type == 'nested_checkbox_group') {
            const parentLabel = value.display_name || value.label
            const childLabels = value.field_values || []
            const stored = uploadParameters[value.label]
            // The parent is a title only; the selection is stored as a flat list of the
            // chosen children (Glue-safe, comma-joined by the backend like checkbox_group).
            // Parent checked = an array exists (possibly empty); unchecked = value removed.
            const parentChecked = Array.isArray(stored)
            const selectedChildren = parentChecked ? stored : []
            const setState = (arr) => {
                if (arr === undefined) {
                    delete uploadParameters[value.label]
                } else {
                    uploadParameters[value.label] = arr
                }
                setUploadParameters({ ...uploadParameters })
                resetDependants()
            }
            element = <SpaceBetween direction="vertical" size="xs">
                <Checkbox
                    checked={parentChecked}
                    onChange={({ detail }) => {
                        setState(detail.checked ? [] : undefined)
                    }}
                    disabled={isDisabled}
                ><Box variant="awsui-key-label">
                    {parentLabel}
                    {value.is_mandatory ? <span style={{ color: 'red' }}> *</span> : ''}
                    {isDisabled && value.limit_permissions ? <span className="small_grey_text_italics"> (restricted)</span> : ''}
                </Box></Checkbox>
                {parentChecked &&
                    <div style={{ paddingLeft: '1.5rem' }}>
                        <SpaceBetween direction="horizontal" size="xs">
                            {childLabels.map((child) => (
                                <Checkbox
                                    key={child}
                                    checked={selectedChildren.includes(child)}
                                    onChange={({ detail }) => {
                                        let current = [...selectedChildren]
                                        if (detail.checked) {
                                            if (!current.includes(child)) current.push(child)
                                        } else {
                                            current = current.filter((v) => v !== child)
                                        }
                                        setState(current)
                                    }}
                                    disabled={isDisabled}
                                >{child}</Checkbox>
                            ))}
                        </SpaceBetween>
                    </div>
                }
            </SpaceBetween>
        } else if (value.field_type == 'numeric_up_down') {
            const current = parseInt(uploadParameters[value.label], 10) || 0
            const digitCount = (uploadParameters[value.label] ?? '0').length
            const commit = (n) => {
                if (n < 0) n = 0
                uploadParameters[value.label] = n.toString()
                setUploadParameters({ ...uploadParameters })
                resetDependants()
            }
            element = <div className="numeric-stepper" style={{ width: `calc(${Math.max(digitCount, 1)}ch + 4rem)` }}>
                <Input value={uploadParameters[value.label] ?? '0'} readOnly disabled={isDisabled} />
                <div className="numeric-stepper__buttons">
                    <button type="button" className="numeric-stepper__btn" aria-label="Increment" disabled={isDisabled} onClick={() => commit(current + 1)}>
                        <Icon name="caret-up-filled" size="small" />
                    </button>
                    <button type="button" className="numeric-stepper__btn" aria-label="Decrement" disabled={isDisabled} onClick={() => commit(current - 1)}>
                        <Icon name="caret-down-filled" size="small" />
                    </button>
                </div>
            </div>
        } else if (value.field_type == 'input') {
            element = <Input
                onChange={({ detail }) => {
                    if (detail.value.trim() === '') {
                        delete uploadParameters[value.label]
                    } else {
                        uploadParameters[value.label] = detail.value
                    }
                    setUploadParameters({ ...uploadParameters })
                    resetDependants()
                }}
                value={uploadParameters[value.label] || ''}
                disabled={isDisabled}
            />
        } else if (value.field_type == 'fixed_inputs') {
            uploadParameters[value.label] = value.field_values
            element = <Box>{value.field_values?.join(',')}</Box>
        } else if (value.field_type == 'dynamic_select') {
            element = <SpaceBetween direction='vertical'>
                <Select
                    selectedOption={uploadParameters[value.label]?.length > 0 ? { label: uploadParameters[value.label], value: uploadParameters[value.label] } : ''}
                    onChange={({ detail }) => {
                        uploadParameters[value.label] = detail.selectedOption.label
                        setUploadParameters({ ...uploadParameters })
                        resetDependants()
                    }

                    }
                    options={resolvedDynamicDropDownValues?.[value.label] || [{ label: parameterError?.[value.label] ? 'Error - see details below' : (dynamicDropDownDependencies?.[value.label]?.['fetching'] ? 'Loading..' : 'Choose all dependency parameters'), value: '', disabled: true }]}
                    disabled={isDisabled}
                />
                {
                    dynamicDropDownDependencies?.[value.label]?.['parametersDependantOn'].length > 0 ? <Box><span className="small_grey_text_italics">Dependant on {dynamicDropDownDependencies?.[value.label]?.['parametersDependantOn']?.join(',')}</span></Box> : ''
                }
                {
                    parameterError?.[value.label] ? <Box><span className="custom-new-upload__error-message "> {parameterError[value.label]} </span></Box> : ''
                }

            </SpaceBetween>
        } else if (value.field_type == 'dynamic_multi_select') {
            let options = []
            let parametersDependantOn = value.field_values?.[0]?.match(/\{([^}]+)\}/g)?.map(match => match.slice(1, -1)) || []
            value.field_values?.forEach((field_value) => {
                options.push({ label: field_value, value: field_value })
            })
            element = <SpaceBetween direction='vertical'>
                <Multiselect
                    selectedOptions={uploadParameters[value.label] ? constructSelectedOptions(uploadParameters[value.label]) : []}
                    onChange={({ detail }) => {
                        let parsedOptions = []
                        detail.selectedOptions?.forEach((selectedOption) => {
                            parsedOptions.push(selectedOption.label)
                        })
                        uploadParameters[value.label] = parsedOptions
                        setUploadParameters({ ...uploadParameters })
                        resetDependants()
                    }
                    }
                    options={resolvedDynamicDropDownValues?.[value.label] || [{ label: parameterError?.[value.label] ? 'Error - see details below' : 'Loading..', value: '', disabled: true }]}
                    placeholder="Choose options"
                    disabled={isDisabled}
                />
                {
                    parametersDependantOn.length > 0 ? <Box><span className="small_grey_text_italics">Dependant on {parametersDependantOn.join(',')}</span></Box> : ''
                }
                {
                    parameterError?.[value.label] ? <Box><span className="custom-new-upload__error-message "> {parameterError[value.label]} </span></Box> : ''
                }
            </SpaceBetween>
        } else if (value.field_type == 'tree') {
            // Author supplies a JSON array of nodes; only leaves (nodes with no children)
            // are selectable. Multi-select: the value is an array of chosen leaf values,
            // and clicking a selected leaf again toggles it back off.
            const selectedValues = Array.isArray(uploadParameters[value.label]) ? uploadParameters[value.label] : []
            const toggleLeaf = (leafValue) => {
                let current = Array.isArray(uploadParameters[value.label]) ? [...uploadParameters[value.label]] : []
                if (current.includes(leafValue)) {
                    current = current.filter((v) => v !== leafValue)
                } else {
                    current.push(leafValue)
                }
                uploadParameters[value.label] = current
                setUploadParameters({ ...uploadParameters })
                resetDependants()
            }
            element = <SpaceBetween direction="vertical" size="xs">
                <FlexicoTreeView
                    json={value.field_values?.[0]}
                    selectedValues={selectedValues}
                    onToggleLeaf={toggleLeaf}
                    disabled={isDisabled}
                />
                {selectedValues.length > 0 &&
                    <StatusIndicator type="success">Selected: {selectedValues.join(', ')}</StatusIndicator>}
            </SpaceBetween>
        } else if (value.field_type == 'date_picker') {
            element = <DatePicker
                value={uploadParameters[value.label] || ''}
                onChange={({ detail }) => {
                    if (!detail.value || detail.value.trim() === '') {
                        delete uploadParameters[value.label]
                    } else {
                        uploadParameters[value.label] = detail.value
                    }
                    setUploadParameters({ ...uploadParameters })
                    resetDependants()
                }}
                placeholder="YYYY-MM-DD"
                disabled={isDisabled}
            />
        } else if (value.field_type == 'date_time_picker') {
            element = <CustomDateTimePicker
                value={uploadParameters[value.label] || ''}
                onChange={(val) => {
                    if (val.trim() === '') {
                        delete uploadParameters[value.label]
                    } else {
                        uploadParameters[value.label] = val
                    }
                    setUploadParameters({ ...uploadParameters })
                    resetDependants()
                }}
                disabled={isDisabled}
            />
        }

        // "info" inline-link + popover next to the title (same pattern as the email fields),
        // shown when the parameter has an info description and/or URL. Text shows in the
        // popover; a URL (http/https) renders as an external link.
        // A parameter carries EITHER a description OR a URL (mutually exclusive in the editor).
        const parsedInfo = parseInfoField(value.info)
        const infoIsUrl = !!parsedInfo.url && isInfoUrl(parsedInfo.url)
        const infoPopover = (parsedInfo.description || parsedInfo.url) ? (
            <Popover
                dismissButton={false}
                position="top"
                size="small"
                triggerType="custom"
                content={
                    parsedInfo.url
                        ? (infoIsUrl
                            ? <Link external href={parsedInfo.url}>{parsedInfo.url}</Link>
                            : <Box>{parsedInfo.url}</Box>)
                        : <Box>{parsedInfo.description}</Box>
                }
            >
                {/* Small Cloudscape "Info" link; shows the external icon when it's a URL. */}
                <Link variant="info">
                    {infoIsUrl ? <>Info <Icon name="external" size="small" /></> : 'Info'}
                </Link>
            </Popover>
        ) : null

        return <>
            {
                !value.is_hidden && <Box key={value.label}>
                    <SpaceBetween direction='vertical' size='s' >
                        {value.field_type != 'nested_checkbox_group' &&
                            <Box variant="awsui-key-label">
                                {value.display_name || value.label}
                                {value.is_mandatory ? <span style={{ color: 'red' }}> *</span> : ''}
                                {isDisabled && value.limit_permissions ? <span className="small_grey_text_italics"> (restricted)</span> : ''}
                                {infoPopover ? <>{' '}{infoPopover}</> : ''}
                            </Box>
                        }
                        {element}
                    </SpaceBetween>
                </Box>
            }</>
        
        
    }

    const uploadData = async () => {
        // If mandatory documents to be uploaded make sure they are attached before allowing them to submit 
        const mandatoryDocsAttribute = flexicoTemplateData?.custom_attributes?.find(
            attr => attr.attribute_type === 'MandatorySupportingDocuments'
        );

        let requiredTypes;
        let uploadedFileTypes;
        if (mandatoryDocsAttribute?.attribute) {
            requiredTypes = mandatoryDocsAttribute.attribute.split(',');
            uploadedFileTypes = inputFiles.map(file => {
                const extension = file.name.split('.').pop().toLowerCase();
                // Map file extensions to document types
                switch(extension) {
                    case 'doc':
                    case 'docx':
                        return 'Word';
                    case 'xlsm':
                    case 'xlsb':
                    case 'xls':
                    case 'xlsx':
                        return 'Excel';
                    case 'pdf':
                        return 'PDF';
                    case 'csv':
                        return 'CSV';
                    default:
                        return extension;
                }
            });
            // Check if all required types are present
            const missingTypes = requiredTypes.filter(
                type => !uploadedFileTypes.includes(type)
            );

            if (missingTypes.length > 0) {
                setMissingMandatoryDocs(missingTypes)
                return;
            }
        }
        if (inputFiles?.length > 0) {
            configureFlexicoS3()
            let sessionId = uuidv4()
            let level = 'public'
            let prefix = 'flexico/'
            let s3_config = getFlexicoS3Config()
            let bucket_name = s3_config.S3.aws_user_files_s3_bucket
            let filePaths = []
            let fileTypes = []
            for (let i = 0; i < inputFiles.length; i++) {
                let fileName = inputFiles[i].name
                let fileData = await inputFiles[i].arrayBuffer();
                setEnableTrigger(false)
                setShowLoadingIcon(true)
                let folder = `source/${sessionId}/${fileName}`
                // await Storage.vault.put(folder, fileData, {
                //     tagging: `userId=${userId}&app_id:${id}&flex_id:${fid}&type=${inputFiles[0].type}`,
                //     level: level,
                //     customPrefix: { public: prefix },
                //     acl: 'bucket-owner-full-control'
                // }).then(result => {
                //     console.log(`${prefix}${result?.key}`)
                //     console.log(inputFiles[i].type)
                //     filePaths.push(`${prefix}${result?.key}`)
                //     fileTypes.push(inputFiles[i].type)
                // }, function (error) {

                // })
            const fnArray = fileName.split('.')
            const contentType = fnArray[fnArray.length - 1]
            const result = await uploadDocumentToVault(contentType, VAULT_SERVICES.FLEXICO, {"file_path": `flexico/${folder}`, "tagging": `userId=${userId}&app_id=${id}&flex_id=${fid}`, "service_id":`${fid}`, "app_id":`${id}`}, fileData)
            filePaths.push(`${result?.objectKey}`)
            fileTypes.push(inputFiles[i].type)
            }
            var tenYearFromNow = new Date();
            tenYearFromNow.setFullYear(tenYearFromNow.getFullYear() + 10);
            createFlexicoTransaction({
                fileId: sessionId,
                flexId: fid,
                appId: id,
                filePath: filePaths.join(','),
                fileExt: fileTypes.join(','),
                status: FLEXICO_TRANSACTION_STATUS.UPLOADED,
                createdTimestamp: Date.now().toString(),
                lastUpdatedTimestamp: Date.now().toString(),
                uploadedTimestamp: Date.now().toString(),
                uploadedBy: userId,
                bucketName: bucket_name,
                ttl: parseInt(tenYearFromNow / 1000).toString(),
                // Carry the checked "optional inputs" as task_manager_inputs:
                // { "<dashboard_id>": { dates:[...] } } in both blobs. In `parameters` the
                // value is JSON-encoded so it lands as a DynamoDB string (S) alongside the
                // other glue params (the backend reader expects S); in `plainParameters`
                // it's the raw object under the un-prefixed key.
                parameters: JSON.stringify({ ...convertAsGlueParams(buildSubmitParameters()), '--task_manager_inputs': JSON.stringify(taskManagerInputs) }),
                plainParameters: JSON.stringify({ ...sanitizeParamKeys(uploadParameters), task_manager_inputs: taskManagerInputs })
            }, function onSuccess(response) {
                setFileReference(sessionId)
                setShowSuccessModal(true)
                setShowLoadingIcon(false)
                setEnableTrigger(true)
            }, function onFailure(error) {
                setErrorMessage(`File was uploaded successfully. But, there was an issue processing, fileId : ${sessionId}`)
                setShowLoadingIcon(false)
                setEnableTrigger(true)
            })

        } else {
            triggerContico()
        }

    }


    const triggerContico = () => {
        setShowLoadingIcon(true)
        setEnableTrigger(false)
        uploadParameters['triggered_by'] = userId
        let sessionId = uuidv4()
        var tenYearFromNow = new Date();
        tenYearFromNow.setFullYear(tenYearFromNow.getFullYear() + 10);
        createFlexicoTransaction({
            fileId: sessionId,
            flexId: fid,
            appId: id,
            status: FLEXICO_TRANSACTION_STATUS.TRIGGER_REQUEST,
            createdTimestamp: Date.now().toString(),
            lastUpdatedTimestamp: Date.now().toString(),
            uploadedTimestamp: Date.now().toString(),
            uploadedBy: userId,
            ttl: parseInt(tenYearFromNow / 1000).toString(),
            // task_manager_inputs in both blobs (see the upload path above):
            // JSON-encoded string under `--task_manager_inputs` in `parameters` (lands
            // as DynamoDB S, which the backend reader expects); raw object in `plainParameters`.
            parameters: JSON.stringify({ ...convertAsGlueParams(buildSubmitParameters()), '--task_manager_inputs': JSON.stringify(taskManagerInputs) }),
            plainParameters: JSON.stringify({ ...sanitizeParamKeys(uploadParameters), task_manager_inputs: taskManagerInputs })
        }, function onSuccess(response) {
            setFileReference(sessionId)
            setShowSuccessModal(true)
            setShowLoadingIcon(false)
            setEnableTrigger(true)
        }, function onFailure(error) {
            setErrorMessage(`There was an issue processing, fileId : ${sessionId}`)
            setShowLoadingIcon(false)
            setEnableTrigger(true)
        })
    }

    const convertAsGlueParams = (params) => {
        let convertedParams = {}
        for(let param in params){
            convertedParams[`--${param}`] = params[param]
        }
        return convertedParams
    }

    // Labels of parameters the user can't currently fill: a non-mandatory group that is
    // collapsed (its opt-in checkbox is unchecked). Once expanded, its params become
    // active again. Mandatory groups are always active.
    const getHiddenGroupLabels = () => {
        const labels = new Set()
        groupAndSortParameters(flexicoTemplateData?.parameters).forEach(group => {
            if (group.group_name !== 'Ungrouped' && group.is_mandatory === false && !openGroups[group.group_id]) {
                group.params.forEach(p => labels.add(p.label))
            }
        })
        return labels
    }

    // Drop empty/whitespace-only keys. A parameter saved with a blank label would land
    // under a "" key, which DynamoDB rejects ("Empty attribute name") and fails the whole
    // createFlexicoTransaction put. Blank-keyed params can't be referenced anyway.
    const sanitizeParamKeys = (obj) => {
        const out = {}
        Object.keys(obj || {}).forEach((k) => {
            if (k != null && String(k).trim() !== '') out[k] = obj[k]
        })
        return out
    }

    // The submit payload. Hidden-group params are never shown/filled, but the Glue job
    // still expects their keys — so we send them explicitly as null rather than dropping
    // them from the payload entirely.
    const buildSubmitParameters = () => {
        const merged = { ...uploadParameters }
        getHiddenGroupLabels().forEach(label => { merged[label] = null })
        return sanitizeParamKeys(merged)
    }

    const handleFlexicoCommentUpdate = (commentText, onSuccess, onFailure) => {
        setIsCommentSubmitting(true);
        updateFlexicoTemplateComment(
            fid,
            commentText,
            userId,
            (result) => {
                // Success callback - reload template data to get updated comment
                setIsCommentSubmitting(false);
                loadData();
                if (onSuccess) {
                    onSuccess(result);
                }
            },
            (error) => {
                // Failure callback
                setIsCommentSubmitting(false);
                console.error('Error updating FlexiCo template comment:', error);
                if (onFailure) {
                    onFailure(error);
                }
            }
        );
    };

    const getCustomAttribute = (attribute_type, sub_type) => {
        const [res] = getCustomAttributeUtil(
            flexicoTemplateData,
            attribute_type,
            sub_type,
            'custom_attributes',
            { attribute_type: 'attribute_type', sub_type: 'sub_type', attribute: 'attribute' }
        );
        return res;
    }

    const getTriggerMessage = () => {
        const customMessage = getCustomAttribute('TRIGGER_MESSAGE', 'FLEXICO')
        return customMessage || "Generating your results may take several minutes. Once complete, you'll receive an email notification. You can access your results by clicking the link in the email or by visiting the History Page and checking the output column."
    }

    const groupAndSortParameters = (parameters) => {
        if (!parameters) return [];
        
        // Parse custom_attributes to get grouping info
        const attributes = flexicoTemplateData?.custom_attributes || [];
        const groupingAttr = Array.isArray(attributes) 
            ? attributes.find(attr => attr.attribute_type === FLEXICO_CUSTOM_ATTRIBUTE_TYPES.GROUPING_PREFERENCE && attr.sub_type === 'FLEXICO')
            : null;
        
        let groupInfo = {};
        let parameterMappingByLabel = {};
        
        if (groupingAttr?.attribute) {
            try {
                const parsed = JSON.parse(groupingAttr.attribute);
                groupInfo = parsed.group_info || {};
                parameterMappingByLabel = parsed.parameter_mapping_by_label || {};
            } catch (e) {
                console.error('Failed to parse grouping attributes:', e);
            }
        }
        
        // Group parameters
        const grouped = parameters.reduce((acc, param, index) => {
            const label = param.label;
            const groupId = parameterMappingByLabel[label] || 'ungrouped';
            const groupData = groupInfo[groupId];
            
            if (!acc[groupId]) {
                acc[groupId] = {
                    group_id: groupId,
                    group_name: groupData?.group_name || 'Ungrouped',
                    group_order: groupData ? parseInt(groupData.group_order) : 0,
                    // Tri-state on purpose: true = mandatory (show + require >=1 filled),
                    // false = explicitly not mandatory (hide), undefined = pre-feature group (show).
                    is_mandatory: groupData?.is_mandatory,
                    params: []
                };
            }
            acc[groupId].params.push(param);
            return acc;
        }, {});
        
        return Object.values(grouped)
            .sort((a, b) => a.group_order - b.group_order)
            .map(group => ({
                ...group,
                params: group.params.sort((a, b) => parseInt(a.display_index || 0) - parseInt(b.display_index || 0))
            }));
    };

    const parametersView = (
        <SpaceBetween size="l">
            {groupAndSortParameters(flexicoTemplateData?.parameters).map((group, groupIndex) => {
                // A named group explicitly marked NOT mandatory is optional: it renders
                // collapsed behind an opt-in checkbox so the user can still choose to fill
                // and submit it. Ungrouped params, mandatory groups (true), and pre-feature
                // groups (undefined) always render.
                const isOptional = group.group_name !== 'Ungrouped' && group.is_mandatory === false
                const groupBox = (
                    <Container
                        header={group.group_name !== 'Ungrouped' ? <Header variant="h3">{group.group_name}</Header> : undefined}
                    >
                        <ColumnLayout columns={2}>
                            {group.params.map((value, index) => getParameterItems(value, index))}
                        </ColumnLayout>
                    </Container>
                )
                if (isOptional) {
                    const isOpen = !!openGroups[group.group_id]
                    return (
                        <SpaceBetween key={`group-${group.group_id}`} size="s">
                            <Checkbox
                                checked={isOpen}
                                onChange={({ detail }) => setOpenGroups(prev => ({ ...prev, [group.group_id]: detail.checked }))}
                            >
                                <Box variant="awsui-key-label">{group.group_name}</Box>
                            </Checkbox>
                            {isOpen && groupBox}
                        </SpaceBetween>
                    )
                }
                return <Box key={`group-${group.group_id}`}>{groupBox}</Box>
            })}
        </SpaceBetween>
    )

    // Optional-inputs accordion (required DATE columns from Task Manager
    // dashboards this template's app is on). It must appear for EVERY trigger
    // type, not just "Upload file with parameters"/"Upload file only", so it is
    // rendered once here and prepended to whichever branch renders below.
    const requiredDateColumnsSection = (
        <RequiredDateColumns
            dashboards={requiredDateDashboards}
            loading={requiredDateLoading}
            error={requiredDateError}
            onSelectionChange={setTaskManagerInputs}
        />
    );

    const uploadOrTriggerContent = () => {
        if (flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.trigger_type) &&
            (flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file with parameters' || flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Upload file only')) {
            return <SpaceBetween size='l'>
                {showLoadingIcon ? (
                    <Box>
                        <Spinner size="normal"></Spinner>
                        {loadingMessage}
                    </Box>) : ''}
                <Container>
                    <SpaceBetween size="l">
                        <div >
                            {showFileNotSeleted ? <Alert type='error'>File Not Selected</Alert> : ''}
                            {flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.upload_mandatory] ? 
                                <Box variant="awsui-key-label">Upload File<span style={{color: 'red'}}> *</span></Box> : ''}
                            {
                                showUploadBtn ? <FileUpload
                                    onChange={({ detail }) => {
                                        setInputFiles(detail.value)
                                        setMissingMandatoryDocs([])
                                    }}
                                    value={inputFiles}
                                    i18nStrings={{
                                        uploadButtonText: e =>
                                            e ? "Choose files" : "Choose file",
                                        dropzoneText: e =>
                                            e
                                                ? "Drop files to generate"
                                                : "Drop file to generate",
                                        removeFileAriaLabel: e =>
                                            `Remove file ${e + 1}`,
                                        limitShowFewer: "Show fewer files",
                                        limitShowMore: "Show more files",
                                        errorIconAriaLabel: "Error"
                                    }}
                                    showFileLastModified
                                    showFileSize
                                    showFileThumbnail
                                    multiple
                                    constraintText="upload input file"
                                /> : <Box></Box>
                            }

                            <br/>
                            <SpaceBetween size="s">
                                {requiredDateColumnsSection}
                                { flexicoTemplateData?.custom_attributes?.find(attr => attr.attribute_type === 'MandatorySupportingDocuments')?.attribute?.length > 0 &&
                                    <Alert
                                        statusIconAriaLabel="Info"
                                        header="Required file types"
                                    >
                                        Please upload the following types files: 
                                        <ul>
                                            {flexicoTemplateData?.custom_attributes?.find(
                                                attr => attr.attribute_type === 'MandatorySupportingDocuments'
                                            )?.attribute.split(',').map((field) => (
                                                <li key={field}>{field}</li>
                                            ))}
                                        </ul>
                                    </Alert>
                                }
                                {
                                    (missingMandatoryDocs.length >= 1 &&
                                        <Alert
                                            statusIconAriaLabel="Error"
                                            type="error"
                                            header="Required file types are missing"
                                        >
                                            <SpaceBetween>
                                                <Box><h4>Missing file types:</h4>
                                                    <ul>
                                                        {Array.from(missingMandatoryDocs).map((field) => (
                                                            <li key={field}>{field}</li>
                                                        ))}
                                                    </ul>
                                                </Box>
                                            </SpaceBetween>
                                        </Alert>
                                    )
                                }
                            </SpaceBetween>

                            {errorMessage ? <Alert statusIconAriaLabel="Error"
                                type="error"
                                header="Upload restricted">
                                {errorMessage} </Alert> : ''}
                        </div>
                    </SpaceBetween>
                </Container>
                {
                    flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.trigger_type] != 'Upload file only' ?
                        parametersView : <></>
                }
                {uploadParameters?.action === CERTIFICATION_ACTION && (
                    <Alert statusIconAriaLabel="Info" header="">
                        <Checkbox
                            onChange={({ detail }) => setCertificationChecked(detail.checked)}
                            checked={certificationChecked}
                        >
                            <strong>I, {userId} (uploader), certify that the deliverable has been reviewed by {flexicoTemplateData?.approvers?.filter(item => item.column_index === 0).map(item => item.alias).join(', ') || 'reviewer'} (reviewer) and approved by {flexicoTemplateData?.approvers?.filter(item => item.column_index === 1).map(item => item.alias).join(', ') || flexicoTemplateData?.approvers?.map(item => item.alias).join(', ') || 'approver'} (approver).</strong>
                        </Checkbox>
                    </Alert>
                )}
                <div className="buttons">
                    <SpaceBetween direction="horizontal" size="l">
                        <Button variant="primary" onClick={uploadData} disabled={!enableTrigger || (uploadParameters?.action === CERTIFICATION_ACTION && !certificationChecked)} >Upload/Execute</Button>
                    </SpaceBetween>
                </div>
            </SpaceBetween>
        } else if (flexicoTemplateData?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.trigger_type)
            && flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.trigger_type] == 'Parameters only') {
            return <SpaceBetween size='l'>
                {
                    parametersView
                }
                {requiredDateColumnsSection}
                <div className="buttons">
                    <SpaceBetween direction="horizontal" size="l">
                        <Button variant="primary" onClick={() => triggerContico()} disabled={!enableTrigger} >Execute</Button>
                    </SpaceBetween>
                </div>
            </SpaceBetween>
        }
        else {
            return <SpaceBetween size='l'>
                {requiredDateColumnsSection}
                <div className="buttons">
                    <SpaceBetween direction="horizontal" size="l">
                        <Button variant="primary" onClick={() => triggerContico()} disabled={!enableTrigger} >Execute</Button>
                        {errorMessage ? <Alert statusIconAriaLabel="Error"
                            type="error"
                            header="Trigger restricted">
                            {errorMessage} </Alert> : ''}
                    </SpaceBetween>
                </div>
            </SpaceBetween>
        }
    }

    const content = (
        <div>

            <SpaceBetween size='xs'>
                     {/* FlexiCo Comment Section using custom_attributes */}
                {/* {!isFlexicoDisabled && isAuthorized && (
                    <ProcessCommentSection
                        processData={flexicoTemplateData}
                        processType="FLEXICO"
                        onCommentUpdate={handleFlexicoCommentUpdate}
                        isAteamBiMember={isSupportAdmin}
                        loading={showLoadingIcon}
                        isSubmitting={isCommentSubmitting}
                    />
                )} */}
                <Container
                    header={
                        <Header
                            variant='h2'
                            actions={
                                <SpaceBetween direction="horizontal" size="xs">
                    <Button variant='normal' onClick={() => { 
                        if (props.selectedSidebarContent) {
                            const historyTab = props.selectedSidebarContent.find(
                                tab => tab.label.toLowerCase() === 'history'
                            );
                            
                            if (historyTab && historyTab.action) {
                                historyTab.action();
                            } else {
                                history.push(`/App/${id}/flexico/${fid}/history${location.search}`);
                            }
                        } else {
                            history.push(`/App/${id}/flexico/${fid}/history${location.search}`);
                        }
                    }}>
                        View History
                    </Button>
                                </SpaceBetween>
                            }
                            description=""
                        > Upload file for template - {getTemplateDisplayName()}


                        </Header>
                    }
                >
                </Container>

                {rerunFlashbarItems.length > 0 && <Flashbar items={rerunFlashbarItems} />}

                {isFlexicoDisabled && <>
                    {
                        disabledMessages?.length > 0 ?
                            <SpaceBetween size='xs' direction='vertical'>{disabledMessages.map((message) => <Alert type='error'>{message}</Alert>)}</SpaceBetween> :
                            <Box>This FlexiCo is disabled. Please contact the process owner for more details.</Box>
                    }
                </>
                }

                {
                    !isFlexicoDisabled && isAuthorized ?
                        uploadOrTriggerContent() :
                        <>
                            {errorMessage ? <Alert statusIconAriaLabel="Error"
                                type="error"
                                header="Trigger restricted">
                                {errorMessage} </Alert> : ''}
                        </>
                }
            </SpaceBetween>


            <Modal
                visible={showSuccessModal}
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="primary" onClick={ModalOkClick}>Ok</Button>
                        </SpaceBetween>
                    </Box>
                }
                header="File Upload Status"
            >
                <Box>
                    <SpaceBetween size='m' direction='vertical'>
                        <p>
                            <Icon variant="success" size='medium' name='status-positive'></Icon>
                            &nbsp; &nbsp;
                            Your trigger was successful. <br/>
                            File reference : {fileReference}
                        </p>
                            {getTriggerMessage()}
                    </SpaceBetween>

                </Box>

                <br></br>

            </Modal>
        </div>
    )
   
    

        return (
        <AppLayout
            content={content}
            navigation={<SideNav activeHref={`/App/${id}/flexico/${fid}/upload`} id={id} fid={fid} process={flexicoTemplateData} back={backUrl} />}
            headerSelector="#TopBar"
            navigationHide={props.disableAppLayout}
            disableBodyScroll={true}
            toolsHide={true}
            headerVariant="high-contrast"
        ></AppLayout>
    ); 

}
